import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const MainMenu = () => {
  const { t } = useTranslation();
 
  const checkActiveOrders = (match: any, location: any) => {
    if (!location) return false;
    const { pathname } = location;
    return pathname === "/" ||
      pathname === "/order-list" ||
      pathname.startsWith("/order-detail")
      ? true
      : false;
  };

  const checkActiveLicences = (match: any, location: any) => {
    if (!location) return false;
    const { pathname } = location;
    return pathname === "/licence-list" ||
      pathname === "/new-licence" ||
      pathname.startsWith("/licence-detail")
      ? true
      : false;
  };

  return (
    <ul className="menu">
      <li>
        <NavLink
          className="menu-link"
          activeClassName="active-link"
          to="/system-list"
        >
          <div>
            <i>
              <svg
                style={{ width: "24px", height: "24px" }}
                viewBox="0 0 24 24"
              >
                <path
                  fill="#ffffff"
                  d="M4,6H20V16H4M20,18A2,2 0 0,0 22,16V6C22,4.89 21.1,4 20,4H4C2.89,4 2,4.89 2,6V16A2,2 0 0,0 4,18H0V20H24V18H20Z"
                />
              </svg>
            </i>
            <span>{t("menu:systems")}</span>
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="menu-link"
          activeClassName="active-link"
          to="/order-list"
          isActive={checkActiveOrders}
        >
          <div>
          <i>
              <svg
                style={{ width: "24px", height: "24px" }}
                viewBox="0 0 24 24"
              >
                <path
                  fill="#ffffff"
                  d="M20,8H4V6H20M20,18H4V12H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"
                />
              </svg>
            </i>
            <span>{t("menu:orders")}</span>
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="menu-link"
          activeClassName="active-link"
          to="/licence-list"
          isActive={checkActiveLicences}
        >
          <div>
            <i>
              <svg
                style={{ width: "24px", height: "24px" }}
                viewBox="0 0 24 24"
              >
                <path
                  fill="#ffffff"
                  d="M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z"
                />
              </svg>
            </i>
            <span>{t("menu:licences")}</span>
          </div>
        </NavLink>
      </li>
    </ul>
  );
};